import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//action
import {
  deleteWhiteListedDevice,
  getWhiteListedDevices,
} from "../store/whiteListedDevices/action";

import { OPEN_WHITE_LISTED_DEVICE_DIALOG } from "../store/whiteListedDevices/types";
//dayjs
import dayjs from "dayjs";
//routing
import { Link } from "react-router-dom";

//sweet alert
import { alert, warningv2, permissionError } from "../util/Alert";

import { IconButton } from "@material-ui/core";
import { Refresh, Warning, Block } from "@material-ui/icons";
import WhiteListDeviceDialog from "../component/dialog/WhiteListDeviceDialog";
import WhiteListedDevicesTable from "../component/table/WhiteListedDevices";

const WhiteListedDevices = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const whiteListedDevices = useSelector(
    (state) => state.whiteListedDevices.whiteListedDevices,
  );

  useEffect(() => {
    props.getWhiteListedDevices();
  }, []);

  useEffect(() => {
    setData(whiteListedDevices);
  }, [whiteListedDevices]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (e) => {
    const value = e.target.value.trim().toUpperCase();
    if (value) {
      const data = whiteListedDevices.filter((data) => {
        return data?.deviceId?.toUpperCase()?.indexOf(value) > -1;
      });
      setData(data);
    } else {
      return setData(whiteListedDevices);
    }
  };

  const handleDelete = (id) => {
    const data = warningv2(
      "DELETE WHITE LISTED DEVICE",
      "Are you sure you want to delete this white listed device?",
    );
    data
      .then((aBoolean) => {
        if (aBoolean) {
          props.deleteWhiteListedDevice(id);
          alert("Success!", `White listed device has been deleted`, "success");
        }
      })
      .catch((error) => console.log(error));
  };

  const handleOpenEditWhiteListedDeviceDialog = (data) => {
    dispatch({ type: OPEN_WHITE_LISTED_DEVICE_DIALOG, payload: data });
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">
              White-Listed Devices for Multiple Accounts
            </h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  White-Listed Devices
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <WhiteListedDevicesTable
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleSearch={handleSearch}
        getWhiteListedDevices={() => props.getWhiteListedDevices()}
        handleOpen={handleOpenEditWhiteListedDeviceDialog}
        handleDelete={handleDelete}
      />
      <WhiteListDeviceDialog />
    </>
  );
};

export default connect(null, {
  getWhiteListedDevices,
  deleteWhiteListedDevice,
})(WhiteListedDevices);
